import type { IssueGridParameters } from '../slices/issueParameters/types';
import { useIssueStore } from '../store';

export type IssueParametersContextType = {
  parameters: IssueGridParameters;
  setParameters: (data: Partial<IssueGridParameters>) => void;
  resetParameters: () => void;
};

export function useIssueParameters(): IssueParametersContextType {
  const parameters = useIssueStore.use.parameters();
  const setParameters = useIssueStore.use.setParameters();
  const resetParameters = useIssueStore.use.resetParameters();

  return {
    parameters,
    setParameters,
    resetParameters,
  };
}
